// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__rqfDX","name":"style_name__2P7_B","description":"style_description__31NH9"};